import { render, staticRenderFns } from "./ingresoVendedor.vue?vue&type=template&id=628e0bc8&scoped=true"
import script from "./ingresoVendedor.vue?vue&type=script&lang=js"
export * from "./ingresoVendedor.vue?vue&type=script&lang=js"
import style0 from "./ingresoVendedor.vue?vue&type=style&index=0&id=628e0bc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628e0bc8",
  null
  
)

export default component.exports